import { toast } from "sonner";
import api from "@/lib/api";

// Anonymous visitor id for public likes (one like per visitor per track).
export function visitorId() {
  try {
    let v = localStorage.getItem("mf_vid");
    if (!v) { v = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`); localStorage.setItem("mf_vid", v); }
    return v;
  } catch { return "anon-visitor-fallback"; }
}

export const toggleLike = (id) => api.post(`/showcase/${id}/like`, { visitor: visitorId() }).then((r) => r.data);

export function shareTrack(t) {
  const url = `${window.location.origin}/api/share/track/${t.id}`;
  const text = `${t.title} — AI game music made with MusicFlow StudioAi`;
  if (navigator.share) return navigator.share({ title: text, text, url }).catch(() => {});
  return navigator.clipboard.writeText(url).then(() => toast.success("Share link copied — rich preview on X, LinkedIn, Discord, Slack.")).catch(() => toast.error("Could not copy the link."));
}
